module.exports = __webpack_public_path__ + "img/B807.17427051.jpg";